import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'app-footer-layout',
  templateUrl: './footer-layout.component.html',
  styleUrls: ['./footer-layout.component.scss']
})
export class FooterLayoutComponent implements OnInit {

  currentYear: number;
  serverName$ = this.sharedService.serverName$;
  constructor(private sharedService : SharedService) {
    this.currentYear = (new Date()).getFullYear();
   }
  ngOnInit(): void {
  }

}
